import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "artifact" }
const _hoisted_2 = { class: "artifact" }
const _hoisted_3 = {
  key: 0,
  class: "artifact-before-after"
}
const _hoisted_4 = { colspan: "2" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = {
  key: 0,
  class: "artifact-before-after"
}
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { colspan: "2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = { class: "artifact-stat" }
const _hoisted_14 = { colspan: "2" }
const _hoisted_15 = { style: {"margin-top":"5px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            (_ctx.before)
              ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.displayName('現在装備')), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("img", {
                          class: "artifact-icon",
                          src: _ctx.artifactImgSrc(_ctx.before),
                          alt: _ctx.displayName(_ctx.before.name)
                        }, null, 8, _hoisted_5)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(_ctx.displayStatStr(_ctx.before.mainStat, _ctx.before.mainStatValue)) + " ", 1),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(_ctx.before.rarity), (dummy) => {
                          return (_openBlock(), _createElementBlock("img", {
                            class: "star",
                            src: "images/star.png",
                            key: dummy
                          }))
                        }), 128))
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.before.subStats, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.name
                      }, [
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.displayStatStr(item.name, item.value)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", null, [
            (_ctx.after)
              ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.displayName('変更後')), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("img", {
                          class: "artifact-icon",
                          src: _ctx.artifactImgSrc(_ctx.after),
                          alt: _ctx.displayName(_ctx.after.name)
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(_ctx.displayStatStr(_ctx.after.mainStat, _ctx.after.mainStatValue)) + " ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(_ctx.after.rarity), (dummy) => {
                          return (_openBlock(), _createElementBlock("img", {
                            class: "star",
                            src: "images/star.png",
                            key: dummy
                          }))
                        }), 128))
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.after.subStats, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.name
                      }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.displayStatStr(item.name, item.value)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isStatsChange)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.displayName('ステータス変化')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStatDiffList, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.key
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.displayName(item.key)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass('value ' + _ctx.statValueClass(item.value))
                        }, _toDisplayString((item.value >= 0 ? '+' : '') + _ctx.displayStatValue(item.key, item.value)), 3)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subStatDiffList, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.key
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.displayName(item.key)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass('value ' + _ctx.statValueClass(item.value))
                        }, _toDisplayString((item.value >= 0 ? '+' : '') + _ctx.displayStatValue(item.key, item.value)), 3)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isStatsChange) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.isStatsChange]
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.displayName('ステータス変化分を適用する')), 1)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyOnClick && _ctx.applyOnClick(...args)))
      }, _toDisplayString(_ctx.displayName('適用')), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelOnClick && _ctx.cancelOnClick(...args)))
      }, _toDisplayString(_ctx.displayName('キャンセル')), 1)
    ])
  ]))
}